import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbSidebarService } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { LayoutService } from '../../../@core/data/layout.service';
import { User } from '../../../shared/models';
import { UserService } from '../../../shared/services';
import 'rxjs/add/operator/finally';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  loadingUser: boolean = false;

  @Input() position = 'normal';

  user: User = new User();

  userName: String = null;

  notification : number = 15;

  userMenu = [{ title: 'Profil', icon: 'fa fa-user', hidden: !this.userService.isHasRoles(["ROLE_PROFILE"]), link: '/users/profil' }, { title: 'Déconnecter', icon: 'fa fa-sign-out-alt', link: '/auth/logout' }];

  constructor(private sidebarService: NbSidebarService,
    public userService: UserService,
    private layoutService: LayoutService,
    public router: Router,
    public toastr: ToastrService) {
  }

  ngOnInit() {
    this.userName = this.userService.getCurrentUserName();
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

}
